/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ReportsInputs */

const cs_nav_reports = /** @type {(inputs: Nav_ReportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporty`)
};

const en_nav_reports = /** @type {(inputs: Nav_ReportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reports`)
};

/**
* | output |
* | --- |
* | "Reports" |
*
* @param {Nav_ReportsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_reports = /** @type {((inputs?: Nav_ReportsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ReportsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_reports(inputs)
	return cs_nav_reports(inputs)
});